import classNames from 'classnames'

interface EmptyBlockProps {
  h?: number
  className?: string
}

const EmptyBlock = ({ h = 150, ...props }: EmptyBlockProps) => {
  const { className } = props
  return <div className={classNames('d-block', className)} style={{ height: `${h}px`, width: '100%' }}></div>
}

export default EmptyBlock
